<template>
  <v-card :class="$style.card">
    <h3
      :class="['text-h3', $style.title]"
      v-if="showTitle"
    >
      <slot name="table-title">
        Основные данные
      </slot>
    </h3>
    <Table
      :class="[
        $style.table,
        { [$style.singleCell]: single_cell_render }
      ]"
      hide-default-footer
      hide-default-header
      disable-pagination
      :items="cols"
      :not_resizeble="true"
    >
      <template v-slot:[`item`]="{ item }">
        <tr
          v-if="!is_mobile"
          :class="[is_even ? $style.tableRow_is_even : $style.tableRow_is_odd, $style.tableRow]"
        >
          <slot
            :name="`item-${item.field}`"
            :props="item"
          >
            <template v-if="!single_cell_render">
              <slot
                :name="`text-item-${item.field}`"
                :item="item"
              >
                <td :class="$style.tableCell">
                  <small>
                    {{ item.text }}
                  </small>
                </td>
              </slot>
              <slot
                :name="`field-item-${item.field}`"
                :item="item"
              >
                <td :class="$style.tableCell">
                  {{ items_info[item.field] }}
                </td>
              </slot>
            </template>
            <template v-else>
              <slot
                :name="`single-item-${item.field}`"
                :item="item"
              />
            </template>
          </slot>
        </tr>
        <div
          v-else
          :class="[$style.flexColumnMobile, 'mb-2']"
        >
          <v-divider class="mb-2" />
          <div
            :class="$style.cellMobileWrapper"
            v-if="!single_cell_render"
          >
            <slot
              :name="`text-item-${item.field}`"
              :item="item"
            >
              <div class="font-weight-bold">{{ item.text }}</div>
            </slot>
            <slot
              :name="`field-item-${item.field}`"
              :item="item"
            >
              <div>{{ items_info[item.field] }}</div>
            </slot>
          </div>
          <template v-else>
            <slot
              :name="`single-item-${item.field}`"
              :item="item"
            />
          </template>
        </div>
      </template>
      <template v-slot:[`footer`]>
        <slot name="footer" />
      </template>
    </Table>
  </v-card>
</template>
<script lang="ts">
import { single_slot_name } from '@/utils';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { global_store } from '@/store';
import { Table } from '../global';
import { VerticalTableCol } from './types';

@Component({
  components: {
    Table,
  },
})
export default class VerticalTable extends Vue {
  @Prop({
    type: Array,
    default: () => ([]),
    required: true,
  })
  cols!: VerticalTableCol[];

  /**
   * Прячем тайтл таблицы
   */
  @Prop({ type: Boolean, default: () => true })
  showTitle?: boolean;

  /**
   * Меняем порядок чередования фона строк таблицы
   */
   @Prop({ type: Boolean, default: () => true })
  is_even?: boolean;

  /**
   * Объект из которого выводим информацю по ключам 'cols'
   */
  @Prop({
    type: Object,
    default: () => ({}),
    required: true,
  })
  items_info!: unknown;

  @Prop({ type: Boolean, default: () => false })
  single_cell_render!: boolean;

  slot_name = single_slot_name;

  can_show_cell(cell: string) {
    return cell in this.$scopedSlots;
  }

  get is_mobile() {
    return global_store.state.isMobile;
  }
}
</script>

<style module lang="scss">
.title {
  padding-bottom: 12px;
  border-bottom: 1px solid;
}

.table {
  margin-top: 16px;
  border-radius: 0;

  .tableRow {

    :global(td) {
      padding-top: 16px !important;
      padding-bottom: 16px !important;
    }

    :global(small) {
      font-size: 14px;
    }

    &:hover {
      :global(td:first-child) {
        border-radius: 0 !important;
      }
    }
  }
}

.singleCell {
  :global(small) {
    color: rgba(0, 0, 0, .5);
  }
}

.tableRow_is_even {
  &:nth-child(even) {
    background-color: $primary_lighten5;
  }
}

.tableRow_is_odd {
  &:nth-child(odd) {
    background-color: $primary_lighten5;
  }
}

.card {
  padding: 16px;
}

@media (max-width: 599px) {
  .tableCell {
    width: 100%;
  }

  .flexColumnMobile {
    display: flex;
    flex-direction: column;
  }

  .cellMobileWrapper {
    display: flex;
    flex-direction: column;
  }
}
</style>
